import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api/useGetQuery";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { type QueryClient } from "@tanstack/react-query";

import type { ProfessionalReferencesResponse } from "../types";
import { professionalReferencesResponseSchema } from "../utils/validation";

const PROFESSIONAL_REFERENCES_URL = `${environmentConfig.REACT_APP_WORKER_SERVICE_URL}/references`;

export async function invalidateProfessionalReferences(queryClient: QueryClient) {
  await queryClient.invalidateQueries({ queryKey: [PROFESSIONAL_REFERENCES_URL] });
}

export function useGetProfessionalReferences(
  options?: UseGetQueryOptions<ProfessionalReferencesResponse>
) {
  return useGetQuery({
    url: PROFESSIONAL_REFERENCES_URL,
    responseSchema: professionalReferencesResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_PROFESSIONAL_REFERENCES_FAILURE,
      userErrorMessage: "Something went wrong while fetching references, please try again.",
    },
    ...options,
  });
}
